import SideNavigation from "./navigation/SideNavigation";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { useEffect } from "react";
import { useAuth } from "./auth/Authcontext";
import { getUserInfo } from "./auth/Api";

function fallbackRender({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
}

export default function AppLayout() {

  const { user , updateUserData } = useAuth()

  useEffect(() => {

    if(user === null){
      getUserInfo().then((response) => {
        updateUserData(response.data)
      })
    }

  },[user])
  return (
    <ErrorBoundary
      fallbackRender={fallbackRender}
      onReset={(details) => {
        // Reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="min-vh-100 h-100 d-flex bg-dark-navy">

        <SideNavigation />
        <div className="d-flex flex-column flex-fill pt-5" style={{ height: "100vh !important", overflow: "scroll" }}>
          <div className="d-flex flex-fill  bg-white p-4 rounded-top-start" > 
            <Outlet />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}
